<template>
  <pui-dialog
    ref="dialog"
    :showCloseButton="false"
    @outsideClick="onCancelCb"
    transition="slide-up"
    noAutoClose
    class="file-deletion-confirmation-dialog file-deletion-confirmation-dialog__root"
  >
    <!-- Confirm close buttons -->
    <template #dialog-action>
      <div class="dialog-action">
        <pui-button @click="onCancelCb" class="confirm-button" variant="secondary" outline>
          {{ $t('dam.files.move.confirm_deletion.buttons.cancel') }}
        </pui-button>
        <pui-button @click="onConfirmCb" class="confirm-close__button" variant="primary">
          {{ $t('dam.files.move.confirm_deletion.buttons.confirm') }}
        </pui-button>
      </div>
    </template>

    <template #title>
      <pui-flex class="file-deletion-confirmation-dialog__title">
        {{
          $tc('dam.files.move.confirm_deletion.title', files.length, {
            count: files.length,
          })
        }}
      </pui-flex>
    </template>

    <template #default>
      <pui-flex
        class="file-deletion-confirmation-dialog__content"
        flex="1"
        justifyContent="center"
        direction="column"
      >
        <i18n class="msg msg-primary" path="dam.files.move.confirm_deletion.message.primary">
          <template #secondary>
            <span class="msg msg-secondary">{{
              $t('dam.files.move.confirm_deletion.message.secondary')
            }}</span>
          </template>
        </i18n>

        <pui-flex class="files-list" justifyContent="center" direction="column">
          <div class="file" v-for="file in files" :key="file.itemId" :title="file.name">
            {{ file.name }}
          </div>
        </pui-flex>
      </pui-flex>
    </template>
  </pui-dialog>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      // Files
      /**
       * The files to move
       */
      files: [],
      onCancelCb: () => {},
      onConfirmCb: () => {},
    };
  },
  methods: {
    // DIALOG
    /**
     * Opens the dialog
     *
     * @returns {void}
     */
    open(files, onCancelCb, onConfirmCb) {
      this.files = files;
      this.onCancelCb = onCancelCb;
      this.onConfirmCb = onConfirmCb;

      this.$refs.dialog.open();
    },
    /**
     * Closes the dialog and resets state
     */
    close() {
      this.$refs.dialog.close();

      this.files = [];
      this.onCancelCb = () => {};
      this.onConfirmCb = () => {};
    },
  },
};
</script>
